// #region Imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { injectIntl, FormattedMessage } from 'react-intl';
import { changeLanguage } from '../../../../actions/language';
import { numberWithCommas } from '../../../../utils/consts';
import { MobileFlightInfoBooking } from '../../../../component';
import { ChevronDownIcon } from '~svg';
import { employeeAllocationApi } from '../../../../services/apis';
import Pagination from 'react-js-pagination';
import momentjs from 'moment-jalaali';
// #endregion

class MobileMyCredit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passengerLst: [],
      creditexpensesList: [],
      data: {
        origin: '',
        destination: '',
        startDate: '',
        endDate: '',
        phrase: '',
        serviceType: '',
        counter: '',
        paymentStatus: '',
      },
      tabFlag: 'issued',
      profileId: 0,
      itemPerPage: 10,
      pageNumber: 1,
      detailPageNumber: 1,
      flights: [],
      creditList: [],
      countercommissionList: [],
      counters: [],
      serviceTypes: [],
      incomesList: [],
      incomesCount: 0,
      countercommissionTotalCount: 0,
      errors: {},
    };
  }
  //#region APIs
  //fetch All credit expenses by creditId
  fetchCreditExpenses = (creditId) => {
    let { detailPageNumber, itemPerPage } = this.state;

    try {
      employeeAllocationApi
        .getAllExpansessbyCreditId({
          creditId,
          pageNumber: detailPageNumber,
          itemPerPage,
        })
        .then((expensesList) => {
          this.setState(
            {
              creditexpensesList: expensesList.payload.data.rows,
              expensesListTotalCount: expensesList.payload.totalRecords,
            },
            () => {},
          );
        })
        .catch((err) => console.log('err', err));
    } catch (error) {
      console.error(error);
    }
  };
  /* Fetch All Credits by EmpId and profileId */
  fetchAllCredits = () => {
    let { pageNumber, itemPerPage } = this.state;
    try {
      employeeAllocationApi
        .getAllProfileAllocationMe({ pageNumber, itemPerPage })
        .then((results) => {
          this.setState({
            creditList: results.payload.data.rows,
            creditListTotalCount: results.payload.totalRecords,
          });
        })
        .catch((err) => console.log('err', err));
    } catch (error) {
      console.error(error);
    }
  };
  // #region life sycle components
  componentDidMount() {
    document.addEventListener('DOMContentLoaded', () => {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    });

    const parsedQueryStr = Object.fromEntries(
      new URLSearchParams(this.props?.location?.search),
    ); //If id exists in query string then fetch data
    if (parsedQueryStr && parsedQueryStr.id)
      this.setState({ profileId: parseInt(parsedQueryStr.id) }, () => {
        this.fetchAllCredits();
      });
  }
  // #endregion

  //#region  Functions
  //Function To Show details for each main Credit record
  setCreditFlag = (index, item) => {
    let creditList = [...this.state.creditList];
    creditList.map((item, ind) => {
      if (index != ind) {
        creditList[ind].showDetail = false;
        creditList[ind].flag = false;
      }
    });
    creditList[index].showDetail = !item.showDetail;
    creditList[index].flag = !item.flag;
    this.setState(
      { creditList, detailPageNumber: 1, expensesListTotalCount: 0 },
      () => {
        this.fetchCreditExpenses(item.id);
      },
    );
  };
  //Change detail Page number
  detailPageChange = (pageNumber, creditId) => {
    this.setState({ detailPageNumber: pageNumber }, () => {
      this.fetchCreditExpenses(creditId);
    });
  };
  //Change Page number
  pageChange = (pageNumber) => {
    this.setState({ pageNumber: pageNumber }, () => {
      this.fetchAllCredits();
    });
  };
  //#endregion
  //#region Renders
  //Render Main record For Profile credits
  renderMainCredit(item, index) {
    let centerClass = 'justify-content-center align-items-center';
    return (
      <div
        key={`mainCredit-${item.id}`}
        className="d-flex w-100 flex-column glass-flight mt-2 "
      >
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
          {this.renderColumn(
            'profilecredit.creditamount',
            `${item.amount} ${item.currency.moneyUnit}`,
            true,
            ` ${centerClass}`,
          )}
          {this.renderColumn(
            'profilecredit.expensesamount',
            `${item.amount - item.remainAmount} ${item.currency.moneyUnit}`,
            true,
            ` ${centerClass}`,
          )}
        </div>
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
          {this.renderColumn(
            'profilecredit.remaincreditamount',
            `${item.remainAmount} ${item.currency.moneyUnit}`,
            true,
            ` ${centerClass}`,
          )}
          {this.renderColumn(
            'profilecredit.assigndate',
            item && item.createdAt && this.props.language.direction === 'ltr'
              ? new Date(item.createdAt).toISOString().split('T')[0]
              : `${momentjs(item.createdAt, 'YYYY-M-D').format(
                  'jYYYY-jMM-jDD',
                )} `,
            false,
            ` ${centerClass}`,
          )}
        </div>
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
          {this.renderColumn(
            'profilecredit.duration',
            item.period,
            true,
            `${centerClass}`,
          )}

          {this.renderColumn(
            'profilecredit.creditstatus',
            item.employeeAllocationStatus.name[this.props.language.name],
            false,
            ` ${centerClass}`,
          )}
        </div>
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center cursor-pointer">
          {item.hasExpenses && this.renderDetailIcon('credits', index, item)}
        </div>
        {this.state.creditexpensesList &&
          this.state.creditexpensesList.length > 0 &&
          this.state.creditexpensesList.map((expense, index) =>
            this.renderDetails(expense, item.showDetail, index),
          )}
        {this.state.creditList[index].showDetail === true &&
          this.state.expensesListTotalCount > 0 &&
          this.renderDetailPaging(this.state.expensesListTotalCount, item.id)}
      </div>
    );
  }

  //Render paging
  renderPaging = (totalCount) => {
    let { pageNumber, itemPerPage } = this.state;
    if (totalCount > 0)
      return (
        <div className="W-100 d-flex p-0 justify-content-center align-items-center">
          <Pagination
            pageRangeDisplayed={5}
            linkClass="page-link"
            itemClass="page-item"
            innerClass="pagination py-2 directionInitial"
            activeClass="active"
            activePage={pageNumber}
            itemsCountPerPage={itemPerPage}
            totalItemsCount={totalCount}
            onChange={(fun) => this.pageChange(fun)}
          />
        </div>
      );
  };
  //Render detail paging
  renderDetailPaging = (totalCount, creditId) => {
    let { detailPageNumber, itemPerPage } = this.state;
    if (totalCount > 0)
      return (
        <div className="W-100 d-flex p-0 justify-content-center align-items-center">
          <Pagination
            pageRangeDisplayed={5}
            linkClass="page-link"
            itemClass="page-item"
            innerClass="pagination py-2 directionInitial"
            activeClass="active"
            activePage={detailPageNumber}
            itemsCountPerPage={itemPerPage}
            totalItemsCount={totalCount}
            onChange={(fun) => this.detailPageChange(fun, creditId)}
          />
        </div>
      );
  };
  //render link to show previous passengers
  // renderPerviousPassengerslink = (passenger, id) => {
  //   return (
  //     <div className="fade modal" id={`PerviousPassengersModal-${id}`}>
  //       <PassengerModal
  //         passengerLst={passenger}
  //         isMobile={true}
  //         modalID={`PerviousPassengersModal-${_id}`}
  //       />
  //     </div>
  //   );
  // };
  // Show All Credits
  renderCreditList = () => {
    if (this.state.creditList.length > 0) {
      return this.state.creditList.map((item, index) =>
        this.renderMainCredit(item, index),
      );
    } else if (this.state.notExist) {
      return (
        <div className="col d-flex p-0 flex-column my-5">
          <div className="col-12 d-flex  justify-content-center align-items-center text-primary font-weight-bold h2">
            <FormattedMessage id="booking.noavailableflight" />
          </div>

          <div className="justify-content-center col-12 d-flex">
            <img
              src={require('../../../../content/images/icon/not-found.png')}
              alt=""
            />
          </div>
        </div>
      );
    }
  };
  //render Detail Icon
  renderDetailIcon = (type, index, item) => {
    return (
      <div
        className={`d-flex mb-3 border-0 text-uppercase bg-transparent text-white   ${
          this.props.language.direction === 'rtl' ? 'font-smaller' : 'font-tiny'
        } justify-content-center align-items-center font-weight-bold outline-none`}
        onClick={() => this.setCreditFlag(index, item)}
      >
        <div className="d-flex justify-content-center align-items-center font-weight-bold ">
          <FormattedMessage id="booking.details" />
        </div>
        <div className="d-flex justify-content-center align-items-center px-1">
          <ChevronDownIcon color="#aaacaf" size={16} />
        </div>
      </div>
    );
  };
  //Render Details for each record
  renderDetails = (item, showDetail, index) => {
    if (showDetail) {
      let flightsLength =
          item.booking && item.booking.flights.itineraries
            ? item.booking.flights.itineraries.length
            : 0,
        totalPassenger =
          parseInt(item.booking.flights.adultCount) +
          parseInt(item.booking.flights.childCount) +
          parseInt(item.booking.flights.infantCount);

      return (
        <div
          className="border m-1 p-0 font-weight-bold text-left  cursor-pointer  mb-1"
          style={{
            borderRadius: '10px',
            border: '2px solid rgba(255, 255, 255, 0.18)',
          }}
        >
          <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
            {this.renderColumn(
              'booking.invoicenumber',
              item.booking.invoiceNo,
              false,
            )}
            {this.renderColumn(
              'booking.orderdate',
              this.props.language.direction === 'ltr'
                ? `${
                    item.booking.orderDate.split('T')[0]
                  } ${item.booking.orderDate.split('T')[1].substring(0, 5)}`
                : momentjs(
                    item.booking.orderDate.split('T')[0],
                    'YYYY-M-D',
                  ).format('jYYYY-jMM-jDD'),
              false,
            )}
          </div>
          <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
            {this.renderColumn(
              'booking.counter',
              `${item.booking.individualProfile.firstName} ${item.booking.individualProfile.lastName}`,
              false,
            )}
            {this.renderColumn(
              'profilecredit.expensesamount',
              `${Number(item.amount).toFixed(2)} ${item.currency.moneyUnit}`,
              true,
            )}
          </div>
          <MobileFlightInfoBooking
            index={index}
            flightLength={flightsLength}
            item={item.booking}
            totalPassenger={totalPassenger}
            //className="w-100"
            pageName="saleAccounting"
          />
        </div>
        // <div
        //   key={`expenses${item.id}`}
        //   className="d-flex flex-row  w-100 py-3 card card-header d-flex justify-content-start"
        // >
        //   <div className="d-flex w-100">
        //     {this.renderColumn("booking.index", index + 1, false, "col-1")}
        //     {this.renderColumn(
        //       "booking.invoicenumber",
        //       item.booking.invoiceNo,
        //       false,
        //       "col-1"
        //     )}
        //     <div className="d-flex p-0 col-1">
        //       <div className=" d-flex justify-content-center align-items-center cursor-pointer">
        //         <div
        //         //   key={`passenger${item.id}`}
        //         //   id={`passenger${item.id}`}
        //           data-placement={`${
        //             this.props.language.direction === "ltr" ? "right" : "left"
        //           }`}
        //           title={`${this.props.intl.formatMessage({
        //             id: "booking.forthepassenger",
        //           })}`}
        //           className="fa fa-info-circle d-flex pointer text-primary "
        //           style={{ fontSize: "1rem" }}
        //         />
        //       </div>
        //     </div>
        //     {this.renderPerviousPassengerslink(item.booking.passengers,item._id)}
        //     {this.renderColumn(
        //       "booking.orderdate",
        //       this.props.language.direction === "ltr"
        //         ? `${
        //             item.booking.orderDate.split("T")[0]
        //           } ${item.booking.orderDate.split("T")[1].substring(0, 5)}`
        //         : momentjs(
        //             item.booking.orderDate.split("T")[0],
        //             "YYYY-M-D"
        //           ).format("jYYYY-jMM-jDD"),
        //       false,
        //       "col-1"
        //     )}
        //     {this.renderColumn(
        //       "booking.from",
        //       item.booking.flights &&
        //         item.booking.flights.itineraries[0].flights &&
        //         item.booking.flights.itineraries[0].flights.length > 0 &&
        //         item.booking.flights.itineraries[0].flights[0].departureAirport
        //           .cityName[name],
        //       false,
        //       "col-1"
        //     )}
        //     {this.renderColumn(
        //       "booking.to",
        //       item.booking.flights.flightType === "onewaytrip"
        //         ? item.booking.flights.itineraries[0].flights[
        //             item.booking.flights.itineraries[0].flights.length - 1
        //           ].arrivalAirport.cityName[name]
        //         : item.booking.flights.itineraries[flightsLength - 1].flights[0]
        //             .departureAirport.cityName[name],
        //       false,
        //       "col-1"
        //     )}
        //     {this.renderColumn(
        //       "booking.totalprice",
        //       `${numberWithCommas(item.booking.totalPrice)} ${
        //         item.booking.moneyUnit.moneyUnit
        //       }`,
        //       false,
        //       "col-2"
        //     )}
        //     {this.renderColumn("booking.guest", totalPassenger, false, "col-1")}
        //     {this.renderColumn(
        //       "booking.counter",
        //       `${item.booking.individualProfile.firstName} ${item.booking.individualProfile.lastName}`,
        //       false,
        //       "col-2"
        //     )}
        //     {this.renderColumn(
        //       "profilecredit.expensesamount",
        //       `${numberWithCommas(item.amount)} ${item.currency.moneyUnit}`,
        //       true,
        //       "col-1"
        //     )}
        //   </div>
        // </div>
      );
    }
  };
  // render column For each record
  renderColumn = (message, value, isNumber, centerClass) => {
    return (
      <div
        className={`d-flex flex-column w-100 text-uppercase font-weight-bold text-third font-smaller px-1 ${centerClass} `}
      >
        <div className="w-100 text-center">
          <FormattedMessage id={message} />
        </div>

        <div className="w-100 text-uppercase font-smaller font-weight-bold text-white pt-2 justify-content-center d-flex">
          {isNumber ? numberWithCommas(value) : value}
        </div>
      </div>
    );
  };
  //Main render
  render() {
    return (
      <div
        className="py-2 col px-3 edit-business-profile-main-div h-100"
        style={{ minHeight: '100vh' }}
      >
        <div className={'d-flex my-3 justify-content-center text-white'}>
          <FormattedMessage id="profilecredit.mycreditmanagement" />
        </div>
        {this.renderCreditList()}
        {this.renderPaging(this.state.creditListTotalCount)}
      </div>
    );
  }
}
//#endregion
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(withRouter(MobileMyCredit)),
);
